function removeCallout(ev) {
  ev.target.className += ' remove';

  window.setTimeout(() => {
    ev.target.parentNode.removeChild(ev.target);
  }, 300);
}

window.addEventListener('load', () => {
  let callouts = document.getElementsByClassName('callout')

  for (var i = 0; i < callouts.length; i++) {
    callouts[i].addEventListener('click', removeCallout)
  }
})




// WEBPACK FOOTER //
// ./javascripts/callout.js